import type { EmailStyleSettings } from "../../style-settings";
import { storedAttributeProps } from "../html-attributes";
import { Heading } from "@react-email/components";
import { getHeadingStyles } from "./styles";
export function HeadingEmailRenderer(attrs: Record<string, unknown>, children?: React.ReactElement, settings?: Partial<EmailStyleSettings>) {
  return <Heading as={`h${attrs.level as 1 | 2 | 3}`} {...storedAttributeProps(attrs)} style={getHeadingStyles(attrs, settings)}>
      {children}
    </Heading>;
}